import axios from 'axios'

class AudioService {
  private audioCache: Map<string, AudioBuffer> = new Map()
  private audioContext: AudioContext | null = null

  constructor() {
    this.audioContext = new AudioContext()
  }

  async getAudioBuffer(audioUrl: string): Promise<AudioBuffer> {
    const cachedBuffer = this.audioCache.get(audioUrl)
    if (cachedBuffer) return cachedBuffer

    if (!this.audioContext) this.audioContext = new AudioContext()
    let data: ArrayBuffer
    if (audioUrl.startsWith('blob:') || audioUrl.startsWith('data:')) {
      const response = await fetch(audioUrl)
      data = await response.arrayBuffer()
    } else {
      const response = await axios.get(audioUrl, {
        responseType: 'arraybuffer',
      })
      data = response.data
    }
    const audioBuffer = await this.audioContext.decodeAudioData(data)
    this.audioCache.set(audioUrl, audioBuffer)
    return audioBuffer
  }
}

export default new AudioService()
